// Формат даты заказа в «Моих заказах» (docs/07-miniapp-ux.md §2.7). Не денежная
// величина и не бизнес-правило — просто локальное представление ISO-даты
// с сервера, тот же приём, что и в frontend/admin (OrderRow.tsx, formatDate).
export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
}
